import * as React from 'react';

import { useProgramCareerAcademyVariantQuery } from 'bundles/unified-career-academy/queries/enterpriseQueries';
import CareerAcademyVariantContext from 'bundles/unified-common/contexts/CareerAcademyVariantContext';
import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';

type Props = {
  children: React.ReactNode;
};

/**
 * @description This component is used to provide the career academy variant for an enterprise program.
 */
const EnterpriseCareerAcademyVariantDataProvider = ({ children }: Props) => {
  const program = useProgram();
  const { careerAcademyVariant, isCareerAcademyVariantLoading } = useProgramCareerAcademyVariantQuery(program?.id);

  return (
    <CareerAcademyVariantContext.Provider value={{ careerAcademyVariant, isCareerAcademyVariantLoading }}>
      {children}
    </CareerAcademyVariantContext.Provider>
  );
};

export default EnterpriseCareerAcademyVariantDataProvider;
